/**
 * The help-center categories, in the order their cards appear on /help.
 *
 * Every folder next to this file must be listed here and every entry must have
 * a folder -- `scripts/check-content.js` fails the build otherwise. The order
 * is the one the content handover (Bimo, 7 Oct 2026, file 01) recommends: most
 * needed first.
 *
 * CommonJS so the build check can read it without webpack.
 *
 * Fields:
 * - `dir`         folder name; the URL slug is derived from it (lib/helpSlug)
 * - `title`       what the reader sees
 * - `icon`        key into components/Help/icons
 * - `description` one sentence under the category title; null hides the line
 * - `badge`       "baru" | "segera" | null. "segera" keeps the card clickable
 *                 and opens an explanatory empty page instead of a dead card.
 * - `subtopics`   optional { [frontMatterSubcategory]: { title, description } },
 *                 in display order. Articles are grouped by their
 *                 `subcategory` front matter; categories without subtopics show
 *                 one list.
 */
module.exports = [
  {
    dir: "Order & Payments",
    title: "Order & Payments",
    icon: "orderPayments",
    description: null,
    badge: null,
    subtopics: {
      general: { title: "Order dan pembayaran", description: null },
      ecommerce: { title: "Bayar lewat e-commerce", description: null }
    }
  },
  { dir: "Ready Stock", title: "Ready Stock", icon: "readyStock", description: null, badge: null },
  { dir: "Pre Order", title: "Pre Order", icon: "preOrder", description: null, badge: null },
  { dir: "Unique Request", title: "Unique Request", icon: "uniqueRequest", description: null, badge: null },
  /*
   * The three process categories are new in October 2026. Every other category
   * is split by product or service, so rules that apply across products -- the
   * unboxing video, claim deadlines, the return flow, refunds -- had no home and
   * were repeated per product with different numbers. These give them one.
   */
  { dir: "Klaim dan Retur", title: "Klaim dan Retur", icon: "klaimRetur", description: null, badge: "baru" },
  { dir: "Dana dan Refund", title: "Dana dan Refund", icon: "danaRefund", description: null, badge: "baru" },
  { dir: "Pengiriman dan Resi", title: "Pengiriman dan Resi", icon: "pengiriman", description: null, badge: "baru" },
  { dir: "Call Service", title: "Call Service", icon: "callService", description: null, badge: "baru" },
  { dir: "Product Inquiry", title: "Product Inquiry", icon: "productInquiry", description: null, badge: null },
  { dir: "Alpha Store", title: "Alpha Store", icon: "alphaStore", description: null, badge: null },
  { dir: "My Account", title: "My Account", icon: "myAccount", description: null, badge: null },
  { dir: "Friendship Points", title: "Friendship Points", icon: "friendshipPoints", description: null, badge: null },
  // Two articles. The handover allows folding it into Order & Payments if a
  // card this small looks odd; kept separate until Bimo decides.
  { dir: "Legal dan Lintas Kanal", title: "Legal dan Lintas Kanal", icon: "legal", description: null, badge: "baru" }
];
